import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalGeneralComponent } from 'src/app/shared/components/modal-general/modal-general.component';
import { environment } from 'src/environments/environment';
declare var hbspt: any;

@Component({
  selector: 'app-plan-de-estudio',
  templateUrl: './plan-de-estudio.component.html',
  styleUrls: ['./plan-de-estudio.component.scss']
})
export class PlanDeEstudioComponent implements OnInit {
  @Input() planData: any;
  @Input() buttonStudyPlan: any;
  @Input() btnUcaState: any;
  @Input() btnUca: any;
  @Input() titlesPlanData: any;
  @Input() dataGeneral: any;
  @Input() workload: any;
  @Input() html = '<p><img alt="" src="https://wadmin.uca.edu.ar/public/Ingreso/Ruedas%20-%20graficos/Econ%C3%B3micas/grafico-contador-publico.png" style="width: 100%;" /></p>';
  @ViewChild('expandableImage') expandableImage!: ElementRef<HTMLImageElement>;
  @ViewChild('contentWrapper') contentWrapper!: ElementRef;
  @ViewChild('finishplanestudio') finishplanestudio!: ElementRef;
  @Input() backgroudColor: string;

  @Input() docentes: any = [];

  selectedItemIndex: number | null = null;
  selectedItemPlan: any = null;
  isModalOpen = false;
  expandedHtml = '';
  scale = 1;
  translateX = 0;
  translateY = 0;
  isDragging = false;
  startX = 0;
  startY = 0;
  lastMouseX = 0;
  lastMouseY = 0;
  openModalForm = false;
  apiUrl = environment.apiUrl;

  htmlsanitizado: any;
  expanded = false;
  showExpandButton = false;
  isDesktop: boolean;
  haveButtons = false;
  constructor(public dialog: MatDialog, private domSanitizer: DomSanitizer) {
  }

  expand() {
    this.isModalOpen = true;
  }

  close() {
    this.isModalOpen = false;
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
  }

  zoom(event: WheelEvent) {
    event.preventDefault();
    const zoomStep = 0.002;
    this.scale += event.deltaY * -zoomStep;
    this.scale = Math.max(0.3, Math.min(3, this.scale));
  }

  startDrag(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging) return;
    const dx = event.clientX - this.lastMouseX;
    const dy = event.clientY - this.lastMouseY;

    this.translateX += dx;
    this.translateY += dy;

    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
  }

  endDrag() {
    this.isDragging = false;
  }


  ngOnInit(): void {
    if (this.buttonStudyPlan) {
      this.buttonStudyPlan.forEach(button => {

        if (button.state == true) {
          this.haveButtons = true;
        }
      });
    }

    this.getPlanData();
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.isDesktop = window.innerWidth > 550;
    this.onSelectItem(0);


    //this.htmlsanitizado = this.domSanitizer.bypassSecurityTrustHtml(this.selectedItemPlan.body);
  }
  async getPlanData() {

    // --- ORDENAR Y FILTRAR ---
    if (this.planData) {
      // Ordeno dejando los popup al final
      this.planData.sort((a, b) => {
        return (a.popup === true ? 1 : 0) - (b.popup === true ? 1 : 0);
      });

      // Mantengo solo items válidos
      this.planData = this.planData.filter(d => d.title && d.body);
    }

    // --- DOCENTES (solo si existen) ---
    if (this.docentes && this.docentes.length > 0) {
      // Expongo la función al window
      (window as any).toggleDocente = this.toggleDocente.bind(this);

      // Esperar hasta que se genere el HTML
      const bodyDocentes = await this.armarBodyDocentes(this.docentes);

      // Agregar item docentes cuando ya está listo
      this.planData.push({
        title: 'Docentes',
        body: bodyDocentes,
        hiddenTitle: true
      });
    }


  }


  ngAfterViewInit() {
    setTimeout(() => {
      const el = this.contentWrapper.nativeElement;
      this.checkStyles();
    }, 0);
    //this.stylesButtons();
  }

  stylesButtons() {

    document.getElementById('button-banner').style.backgroundColor = this.dataGeneral.banner_dos_button_background_color;
    document.getElementById('button-banner').style.color = this.dataGeneral.banner_dos_button_text_color;
    document.getElementById('button-banner').style.borderColor = this.dataGeneral.banner_dos_button_border_color;

  }

  checkStyles() {
    this.isDesktop = window.innerWidth > 768;

    var banner2 = document.getElementById("banner2");
    if (banner2) {
      this.dataGeneral.banner_dos_button_text_size = 19;  //font-size btn

      var banner2Title = document.getElementById("banner2-title");
      var banner2Subtitle = document.getElementById("banner2-subtitle");
      var banner2Btn = document.getElementById("button-banner");

      // Calcular tamaños finales (ya responsivos)
      var banner2TitleSize = this.getResponsiveSize(this.dataGeneral.banner_dos_title_font_size);
      var banner2SubtitleSize = this.getResponsiveSize(this.dataGeneral.banner_dos_text_font_size);
      var banner2BtnSize = this.getResponsiveSize(this.dataGeneral.banner_dos_button_text_size);

      // Asignar font-size
      banner2Title.style.fontSize = banner2TitleSize + "px";
      banner2Subtitle.style.fontSize = banner2SubtitleSize + "px";
      banner2Btn.style.fontSize = banner2BtnSize + "px";

      // Definir line-height relativo al tamaño final
      banner2Title.style.lineHeight = banner2TitleSize * 1.3 + "px";
      banner2Subtitle.style.lineHeight = banner2SubtitleSize * 1.4 + "px";
    }


    this.checkShowMore();
  }

 checkShowMore() {
    let showMore = this.selectedItemPlan.showMore;
    if(showMore) {
    this.isDesktop = window.innerWidth > 768;
    setTimeout(() => {
      const wrapper = this.contentWrapper.nativeElement;
      const inner = wrapper.querySelector('.bodyplan');

      if (this.isDesktop && wrapper) {
        const innerHeight = inner.scrollHeight;
        const maxHeightPx = window.innerWidth * 0.35;
        this.expanded = false;
        this.showExpandButton = innerHeight > maxHeightPx;
      } else {
        this.expanded = true;
        this.showExpandButton = false;
      }
    }, 0);
    }else {
        this.expanded = true;
        this.showExpandButton = false;
     }
  }

  getResponsiveSize(base: any): any {
    const width = window.innerWidth;
    const size = parseInt(base);

    if (width >= 1920) return size;
    if (width >= 768) {
      const maxWidth = 1920;
      const minWidth = 768;
      const baseFactor = 0.3;
      const factor = baseFactor + (width - minWidth) / (maxWidth - minWidth) * (1 - baseFactor);
      return size * factor;
    }
    if (width > 480) return size * 0.9;
    return size * 0.5;
  }

  toggleExpand() {
    this.expanded = !this.expanded;
    if (!this.expanded) {
      setTimeout(() => {
        this.finishplanestudio.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0); // espera a que Angular actualice la vista
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkStyles();
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isModalOpen) {
      this.closeImage();
    }
  }
  titlehtml: any;
  onSelectItem(index: number) {

    if (this.planData && this.planData[index]) {
      this.selectedItemIndex = index;
      this.selectedItemPlan = this.planData[index];
      this.titlehtml = this.selectedItemPlan.title;
      if (this.selectedItemPlan.hiddenTitle) this.titlehtml = "";

      if (this.selectedItemPlan.popup == true) {
        this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: this.selectedItemPlan.body, title: this.selectedItemPlan.title, tipografy: "nunito-medium", tipografyTitle: "nunito-bold" } });
        this.htmlsanitizado = "";
        this.titlehtml = "";
        this.checkShowMore();
      } else {
        const body = this.selectedItemPlan.body.replace(
          /<(h[1-5]|span)([^>]*)>/g,
          `<$1$2 style="color: ${this.backgroudColor}">`
        );
        this.htmlsanitizado = this.domSanitizer.bypassSecurityTrustHtml(body);

        this.checkShowMore();

      }
    }

  }



  expandImage() {
    this.isModalOpen = true;
    this.scale = 1;
  }

  closeImage() {
    this.isModalOpen = false;
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
  }


  openModal() {
    this.openModalForm = true;
    /*hbspt.forms.create({
      region: "na1",
      portalId: "23647426",
      formId: "b2e6899b-83b4-4a49-92ff-92360afdd10d",
      target: '#hubspot-form-modal'
    });*/
  }
  closeModal() {
    this.openModalForm = false;
  }

  restart(index) {
    var i = 0;
    this.planData.forEach(item => {
      if (i != index && document.getElementById('id-' + i)) {
        document.getElementById('id-' + i).innerHTML = "";
        document.getElementById('id-' + i).style.position = "relative"
        document.getElementById('arrowdown-' + i).style.display = "block";
        document.getElementById('arrowup-' + i).style.display = "none";
        document.getElementById('id-' + i).style.paddingTop = "0px";
        document.getElementById('id-' + i).style.paddingBottom = "0px";
        document.getElementById('id-' + i).style.marginBottom = "0px";
      }
      i++;
    })
  }

  open(button) {
    this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: button.body, title: button.title } });

  }


  openPlan(item, i) {
    //this.restart(i);
    document.getElementById('id-' + i).innerHTML = item.body;
    document.getElementById('arrowdown-' + i).style.display = "none";
    document.getElementById('arrowup-' + i).style.display = "block";
    document.getElementById('id-' + i).style.paddingTop = "20px";
    document.getElementById('id-' + i).style.paddingBottom = "20px";
    document.getElementById('id-' + i).style.marginBottom = "2em";


  }

  closePlan(i) {
    // this.restart(i);
    document.getElementById('id-' + i).innerHTML = "";
    document.getElementById('arrowdown-' + i).style.display = "block";
    document.getElementById('arrowup-' + i).style.display = "none";
    document.getElementById('id-' + i).style.paddingTop = "0px";
    document.getElementById('id-' + i).style.paddingBottom = "0px";
    document.getElementById('id-' + i).style.marginBottom = "0px";


  }
  openClosePanel(item, i) {
    if (document.getElementById('id-' + i).innerHTML == "") {
      this.openPlan(item, i);
    } else {
      this.closePlan(i)
    }
  }
  openDate() {
    // this.restart(null);
    var innerHTML = this.buttonStudyPlan[0].body;
    this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: innerHTML, title: 'Días y horarios de cursada' } });

    document.getElementById('date').style.position = "absolute";
    document.getElementById('arrowdowndate').style.display = "none";
    document.getElementById('arrowupdate').style.display = "inline";
  }
  closeDate() {
    document.getElementById('date').innerHTML = "";
    document.getElementById('date').style.position = "relavite";
    document.getElementById('arrowdowndate').style.display = "inline";
    document.getElementById('arrowupdate').style.display = "none";
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }
  flechaAbajoImg = '';
  flechaArribaImg = '';

  async armarBodyDocentes(docentes: any[]) {
    const tarjetas = await Promise.all(
      docentes.map(async (d, index) => {

        const redesHtml = await this.generarRedes(d);
        await this.armarFlechas();

        const tieneContenidoExtra =
          (d.description && d.description.trim() !== '') ||
          redesHtml.trim() !== '';
        return `
        <div class="docente-card">

          <div class="header">
            <img 
              class="foto" 
              src="${d.image ? environment.apiUrl + d.image : './assets/img/default-docentes.png'}" 
              alt="${d.name}"
              onerror="this.onerror=null; this.src='./assets/img/default-docentes.png';"
            />

            <div class="datos">
               ${d.name ? `<h3>${d.name}</h3>` : ''}
              <hr class="separador" style="border-bottom-color: ${this.backgroudColor};">

              ${d.title ? `<h4>${d.title}</h4>` : ''}

              <ul>
                ${d.items.map(s => `<li>${s.texto}</li>`).join('')}
              </ul>

              <div class="cuerpo oculto" id="cuerpo-${index}">
                ${d.description ? `<p>${d.description}</p>` : ''}
                <div class="redes">
                  ${redesHtml}
                </div>
              </div>

              ${tieneContenidoExtra ? `
                <div class="toggle" onclick="toggleDocente(${index})">
                  <img 
                    src="${this.flechaAbajoImg}" 
                    id="flecha-down-${index}" 
                    class="flecha flecha-down"
                  />

                  <img 
                    src="${this.flechaArribaImg}" 
                    id="flecha-up-${index}" 
                    class="flecha flecha-up oculto"
                  />
                </div>

                <hr class="separador" style="border-bottom-color: ${this.backgroudColor};">
              ` : ''}
              
            </div>

          </div>
              

        </div>
      `;
      })
    );

    return tarjetas.join('');
  }

  async armarFlechas() {
    const downSvg = await (await fetch('./assets/svg/flecha-abajo.svg')).text();
    const upSvg = await (await fetch('./assets/svg/flecha-arriba.svg')).text();

    const downColored = this.changeSvgColor(downSvg, this.backgroudColor);
    const upColored = this.changeSvgColor(upSvg, this.backgroudColor);

    this.flechaAbajoImg = await this.svgToPngUrl(downColored, 30);
    this.flechaArribaImg = await this.svgToPngUrl(upColored, 30);
  }


  async generarRedes(d: any) {
    const redes = [
      { campo: "instagram", icono: "./assets/svg/instagram.svg" },
      { campo: "linkedin", icono: "./assets/svg/linkedin.svg" },
      { campo: "facebook", icono: "./assets/svg/facebook.svg" },
      { campo: "twitter", icono: "./assets/svg/twitter.svg" },
      { campo: "youtube", icono: "./assets/svg/youtube.svg" }
    ];

    const svgPromises = redes
      .filter(red => d[red.campo] && d[red.campo]?.trim() !== "")
      .map(async red => {

        let svgText = await (await fetch(red.icono)).text();
        svgText = this.changeSvgColor(svgText, this.backgroudColor);


        const pngUrl = await this.svgToPngUrl(svgText, 40);

        return `
        <a href="${d[red.campo]}" target="_blank" class="red-link">
          <img src="${pngUrl}" class="icon-red">
        </a>
      `;
      });

    return (await Promise.all(svgPromises)).join('');
  }


  changeSvgColor(svg: string, color: string): string {
    svg = svg.replace(/fill\s*=\s*["']#[0-9a-fA-F]{3,6}["']/g, `fill="${color}"`);
    svg = svg.replace(/fill:\s*#[0-9a-fA-F]{3,6}/g, `fill:${color}`);

    return svg;
  }
  svgToPngUrl(svg: string, size = 30): Promise<string> {
    return new Promise(resolve => {
      const img = new Image();
      const svgBlob = new Blob([svg], { type: "image/svg+xml" });
      const url = URL.createObjectURL(svgBlob);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext("2d")!;
        ctx.drawImage(img, 0, 0, size, size);

        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/png")); // 👉 devuelve la image generada
      };

      img.src = url;
    });
  }
  toggleDocente(i) {
    const cuerpo = document.getElementById("cuerpo-" + i);

    const flechaDown = document.getElementById("flecha-down-" + i);
    const flechaUp = document.getElementById("flecha-up-" + i);

    const estabaOculto = cuerpo.classList.contains("oculto");

    // Abrir
    if (estabaOculto) {
      cuerpo.classList.remove("oculto");
      cuerpo.classList.add("open");

      flechaDown.classList.add("oculto");
      flechaUp.classList.remove("oculto");
    }
    // Cerrar
    else {
      cuerpo.classList.add("oculto");
      cuerpo.classList.remove("open");

      flechaUp.classList.add("oculto");
      flechaDown.classList.remove("oculto");
    }
    setTimeout(() => {
      this.checkShowMore();
    }, 50);
  }
openUcaLink() {
  window.open(this.btnUca, '_blank');
}
}
